import { useState } from 'react';
import { fileApi } from '../../../api/fileApi';

/**
 * The one file of the upload form: uploads it as soon as it is picked and can
 * delete it from the server again. `uploadId` is set once the upload finished.
 */
export function useUploadedFile(notifyError) {
  const [file, setFile] = useState(null);
  const [uploadId, setUploadId] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const clear = () => {
    setFile(null);
    setUploadId(null);
    setUploading(false);
    setProgress(0);
    setError(null);
  };

  const select = async (selected) => {
    setFile(selected);
    setUploading(true);
    setProgress(0);
    setError(null);
    try {
      const result = await fileApi.uploadFile(selected, setProgress);
      setProgress(100);
      if (result?.id) setUploadId(result.id);
    } catch (err) {
      setError(err.message || 'Upload failed');
      setProgress(0);
      setFile(null);
      notifyError('Upload failed', 'The file could not be uploaded. Please try again.');
    } finally {
      setUploading(false);
    }
  };

  /** Resolves true once the server copy is gone. */
  const deleteUploaded = async () => {
    setDeleting(true);
    try {
      await fileApi.deleteFile(uploadId);
      clear();
      return true;
    } catch (err) {
      notifyError('Delete failed', err.message);
      return false;
    } finally {
      setDeleting(false);
    }
  };

  return { file, uploadId, uploading, progress, error, deleting, select, clear, deleteUploaded };
}
